// ops — третий iPhone-виджет: Javelin, сессии за сегодня по LA
// (Scriptable, стиль Lightning Lime). GET /api/ops/widget-javelin,
// тот же Bearer OPS_WIDGET_TOKEN.
import { z } from 'zod';

export const OpsWidgetJavelinModSchema = z.object({
  mod_id: z.string(),
  name: z.string(),          // display_name из moderators
  today: z.number(),         // снято сегодня (день LA, канон «не отменено»)
  last_at: z.string().nullable(), // ISO последнего интейка
});

export const OpsWidgetJavelinResSchema = z.object({
  generated_at: z.string(),
  la_date: z.string(),       // YYYY-MM-DD дня LA, за который счёт
  mods: z.array(OpsWidgetJavelinModSchema),
});
export type OpsWidgetJavelinRes = z.infer<typeof OpsWidgetJavelinResSchema>;
